var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppleLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4975 9.66702C13.5146 8.34391 14.2082 7.12175 15.3355 6.42874C14.6211 5.40852 13.4675 4.78487 12.2227 4.74592C10.913 4.60845 9.64332 5.52961 8.97592 5.52961C8.29562 5.52961 7.26807 4.75957 6.16157 4.78233C4.70571 4.82937 3.38135 5.63705 2.67304 6.90986C1.16471 9.52136 2.28979 13.3594 3.73468 15.4704C4.45759 16.504 5.30245 17.6587 6.40796 17.6177C7.48976 17.5728 7.89379 16.9279 9.19961 16.9279C10.4933 16.9279 10.8724 17.6177 12.0003 17.5917C13.1611 17.5728 13.8925 16.5534 14.5901 15.51C15.1095 14.7734 15.5092 13.9594 15.7743 13.098C14.3956 12.5149 13.4991 11.164 13.4975 9.66702Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3671 3.35761C12 2.5978 12.3118 1.6212 12.2363 0.635193C11.2694 0.736754 10.3761 1.1989 9.73467 1.92956C9.10124 2.65045 8.78034 3.59356 8.84266 4.55118C9.8226 4.56127 10.753 4.12135 11.3671 3.35761Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogo);
export default __webpack_public_path__ + "static/media/apple-logo.4f2453fbf206c78dfc37a878a1cf07b7.svg";
export { ForwardRef as ReactComponent };